import styled from 'styled-components';
import Categorie from './Categorie';
import Hotel from './../../../../assets/svg/hotel.svg';
import Resturant from './../../../../assets/svg/Resturant.svg';
import BookShop from './../../../../assets/svg/bookShop.svg';
import stainoryIcon from './../../../../assets/svg/stainoryIcon.png';
import JewelleryIcon from './../../../../assets/img/jewellery.png';


import Saloon from './../../../../assets/img/Saloon.png';
import Parlor from './../../../../assets/img/Parlor.png';
import FoodCity from './../../../../assets/img/foodCity.png';

import Bakery from './../../../../assets/img/Bakery.png';
import FruiteShop from './../../../../assets/img/fruiteShop.png';
import vegitables from './../../../../assets/img/vegitables.png';




import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import WatchOutlinedIcon from '@mui/icons-material/WatchOutlined';

import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined';
import SchoolIcon from '@mui/icons-material/School';
import { render } from '@testing-library/react';


const xx=()=>{
  render(
          <svg width={24} height={24} viewBox="0 0 24 24" className="svg-wrapper--8ky9e"><defs><path id="mobiles_svg__a" d="M0 .76h12v24H0z" /><path id="mobiles_svg__c" d="M0 25h12V1.24H0z" /><path d="M8 7.096c0 .575-.418 1.042-.934 1.042H.934C.418 8.138 0 7.67 0 7.096V1.179C0 .604.418.138.934.138h6.132C7.582.138 8 .604 8 1.179v5.917z" id="mobiles_svg__e" /></defs><g transform="translate(6 -1)" fill="none" fillRule="evenodd"><g transform="translate(0 .24)"><mask id="mobiles_svg__b" fill="#fff"><use xlinkHref="#mobiles_svg__a" /></mask><path d="M2.595 4.101V2.06A1.298 1.298 0 1 0 0 2.06V21.73c0 3.386 2.686 3.019 6 3.019s6 .367 6-3.019V6.35c0-1.242-.965-2.249-2.155-2.249h-7.25z" fill="#59BCD1" mask="url(#mobiles_svg__b)" /></g><path d="M3.638 18.643a.456.456 0 0 1-.455.456H1.778a.456.456 0 0 1-.455-.456V17.24c0-.25.204-.455.455-.455h1.405c.25 0 .455.204.455.455v1.404z" fill="#2CA4A9" /><path d="M3.183 16.784H1.778a.456.456 0 0 0-.455.455v.862c0-.252.204-.456.455-.456h1.405c.25 0 .455.204.455.456v-.862a.456.456 0 0 0-.455-.455" fill="#2A8F9E" /><path d="M10.914 18.643a.456.456 0 0 1-.455.456H9.054a.455.455 0 0 1-.455-.456V17.24c0-.25.204-.455.455-.455h1.405c.25 0 .455.204.455.455v1.404z" fill="#2CA4A9" /><path d="M10.458 16.784H9.054a.456.456 0 0 0-.455.455v.862c0-.252.204-.456.455-.456h1.404c.251 0 .456.204.456.456v-.862a.456.456 0 0 0-.456-.455" fill="#2A8F9E" /><path d="M7.276 18.643a.456.456 0 0 1-.455.456H5.416a.455.455 0 0 1-.455-.456V17.24c0-.25.204-.455.455-.455H6.82c.25 0 .455.204.455.455v1.404z" fill="#2CA4A9" /><path d="M6.82 16.784H5.416a.456.456 0 0 0-.455.455v.862c0-.252.204-.456.455-.456H6.82c.252 0 .456.204.456.456v-.862a.456.456 0 0 0-.456-.455" fill="#2A8F9E" /><path d="M3.638 22.281a.456.456 0 0 1-.455.456H1.778a.456.456 0 0 1-.455-.456v-1.404c0-.25.204-.455.455-.455h1.405c.25 0 .455.204.455.455v1.404z" fill="#2CA4A9" /><path d="M3.183 20.422H1.778a.456.456 0 0 0-.455.455v.862c0-.252.204-.456.455-.456h1.405c.25 0 .455.204.455.456v-.862a.456.456 0 0 0-.455-.455" fill="#2A8F9E" /><path d="M10.914 22.281a.456.456 0 0 1-.455.456H9.054a.455.455 0 0 1-.455-.456v-1.404c0-.25.204-.455.455-.455h1.405c.25 0 .455.204.455.455v1.404z" fill="#2CA4A9" /><path d="M10.458 20.422H9.054a.456.456 0 0 0-.455.455v.862c0-.252.204-.456.455-.456h1.404c.251 0 .456.204.456.456v-.862a.456.456 0 0 0-.456-.455" fill="#2A8F9E" /><path d="M7.276 22.281a.456.456 0 0 1-.455.456H5.416a.455.455 0 0 1-.455-.456v-1.404c0-.25.204-.455.455-.455H6.82c.25 0 .455.204.455.455v1.404z" fill="#2CA4A9" /><path d="M5.416 20.422a.456.456 0 0 0-.455.455v.862c0-.252.204-.456.455-.456H6.82c.252 0 .456.204.456.456v-.862a.456.456 0 0 0-.456-.455H5.416z" fill="#2A8F9E" /><mask id="mobiles_svg__d" fill="#fff"><use xlinkHref="#mobiles_svg__c" /></mask><path fill="#2CA4A9" mask="url(#mobiles_svg__d)" d="M0 4h2.6V3H0z" /><g mask="url(#mobiles_svg__d)"><g transform="translate(2 6.862)"><mask id="mobiles_svg__f" fill="#fff"><use xlinkHref="#mobiles_svg__e" /></mask><use fill="#F1F0E5" xlinkHref="#mobiles_svg__e" /><path d="M.443 0C.313 0 .191.026.075.067l8.493 8.219c.212-.204.346-.49.346-.807V1.12A1.12 1.12 0 0 0 7.794 0H.444z" fill="#E4E3D7" mask="url(#mobiles_svg__f)" /></g></g></g></svg>
  )
};





function AllCategories({className=""}) {
  return (
    <DIV className={`${className} mt-4`}>

        <div className="font-1-4">Category</div>
         <div className="AllCategories-wrapper mt-3">


           
            <Categorie   className='mt-2'  text="Hotel" number="(1278)"  svgIcon={<img src={Hotel} className=" w-8 category-icon "/>}></Categorie>
            <Categorie   className='mt-2'  text="Resturant" number="(1278)"  svgIcon={<img src={Resturant} className=" w-8 category-icon "/>}></Categorie>
            <Categorie   className='mt-2'  text="Book Shop" number="(1278)"  svgIcon={<img src={BookShop} className=" w-8 category-icon "/>}></Categorie>
            <Categorie   className='mt-2'  text="Stationary Shop" number="(1278)"  svgIcon={<img src={stainoryIcon} className=" w-8 category-icon "/>}></Categorie>
            <Categorie   className='mt-2'  text="Jewelry" number="(1278)"  svgIcon={<img src={JewelleryIcon} className=" w-8 category-icon "/>}></Categorie>
            
            
            <Categorie   className='mt-2'  text="Saloon" number="(1278)"  svgIcon={<img src={Saloon} className=" w-8 category-icon "/>}></Categorie>
         
            <Categorie   className='mt-2'  text="Beauty Parlor" number="(1278)"  svgIcon={<img src={Parlor} className=" w-8 category-icon "/>}></Categorie>
            <Categorie   className='mt-2'  text="Food CIty" number="(1278)"  svgIcon={<img src={FoodCity} className=" w-8 category-icon "/>}></Categorie>

        <Categorie   className='mt-2'  text="Bakery" number="(1278)"  svgIcon={<img src={Bakery} className=" w-8 category-icon "/>}></Categorie>
            <Categorie   className='mt-2'  text="Fruite Shop" number="(1278)"  svgIcon={<img src={FruiteShop} className=" w-8 category-icon "/>}></Categorie>
       
            <Categorie   className='mt-2'  text="Vegetable Shop" number="(1278)"  svgIcon={<img src={vegitables} className=" w-8 category-icon "/>}></Categorie>


         </div>
    </DIV>
  );
}


const DIV=styled.div`
    width: 100%;
    /* margin-top: var(--margin-top-fix-nav);  */  /*only AllCategories */
    
    .AllCategories-wrapper{
      /* width: var(--AllCategories-content-width);
        margin-left: auto;
        margin-right: auto;  */

        .category-icon{
          
        }

    }
`;

export default AllCategories;
